import React, { useEffect, useState } from 'react'
import { Grid, Stack } from '@mui/material'

import HomeIcon from '@mui/icons-material/Home';
import ApartmentIcon from '@mui/icons-material/Apartment';
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { MainContainer } from '../../containers';
import { ModalHeader } from '../../modals';
import { customStyles } from '../../../styles';
import { RegularTab } from '../../helpers/tabs/RegularTab';
import { MainButton } from '../../helpers';
import { NoAccounts } from './NoAccounts';
import { resetForm } from '../../../slices/fillAddressSlice';

export const AllAccounts = React.forwardRef(( props, ref) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { data} = useSelector(state => state.accounts)

  
  const handleNavigate = () => {
    navigate(`/dashboard/address-form`)
 }
  const backward = () => {
    navigate(-1)
 }

 useEffect(() => {
  dispatch(resetForm())
 }, [])
  return (
    
   <MainContainer>
      <ModalHeader text="Direcciones" backward action={backward} bold color={ customStyles.colors.main }/>
      <Grid container xs={12} spacing={3} mb={3}>
      {
        data.length > 0
        ? data?.map(item => (
          <RegularTab id={item.id}key={item.id} icon={HomeIcon} title={item.alias} content={`${item.street} ${item.extNumber} ${item.colony} ${item.postalCode}`} serviceType={item.type} postalCode={item.postalCode} route="product" data={item} all/>
          ))

          : <NoAccounts />
        }
    </Grid>
   </MainContainer>
  )
})
